export const TooltipLinePlugin = {
    id: 'tooltipLine',
    beforeDraw: (chart: any) => {
        if (chart.tooltip?._active?.length) {
            const { ctx } = chart;
            const x = chart.tooltip._active[0].element.x;
            const yAxis = chart.scales.y;
            ctx.save();
            ctx.beginPath();
            ctx.moveTo(x, yAxis.top);
            ctx.lineTo(x, yAxis.bottom);
            ctx.lineWidth = 1;
            ctx.strokeStyle = '#000000';
            ctx.setLineDash([4, 4]);
            ctx.stroke();
            ctx.restore();
        }
    },
};